(function () {
    var root = document.querySelector('[data-lmm-header]');
    if (!root || root.dataset.lmmInit === '1') { return; }
    root.dataset.lmmInit = '1';

    function num(n) { return (typeof n === 'number') ? n.toLocaleString('de-DE') : ''; }
    function parseJSON(sel) { var el = root.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function alphaSort(arr) {
      return (arr || []).slice().sort(function (a, b) { return (a.n || '').localeCompare(b.n || '', 'de', { numeric: true }); });
    }
    var SHY = String.fromCharCode(0xAD);
    function softHyph(s) {
      if (!s) { return s; }
      var fugen = ['leuchtmittel', 'leuchtstoff', 'beleuchtung', 'leuchten', 'batterien', 'lampen', 'röhren', 'roehren', 'geräte', 'geraete', 'systeme', 'sockel', 'dampf', 'spar'];
      fugen.forEach(function (f) {
        s = s.replace(new RegExp('([a-zA-ZäöüÄÖÜß]{3,})(' + f + ')', 'gi'), function (m, pre, mk) { return pre + SHY + mk; });
      });
      return s;
    }
    // Dezente Gruppen-Icons (currentColor = LMM-Rot).
    var I = {
      bulb: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.7 10.7c.6.5.9 1.1.9 1.8v.5h5.6v-.5c0-.7.3-1.3.9-1.8A6 6 0 0 0 12 3Z"/></svg>',
      spot: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10l-1.5 7h-7L7 4Z"/><path d="M10 11v3m4-3v3M9.5 18h5"/></svg>',
      tube: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="18" height="6" rx="3"/><path d="M6.5 9.5v5m11-5v5"/></svg>',
      pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10v5a5 5 0 0 1-10 0V4Z"/><path d="M10.5 19v-2m3 2v-2"/></svg>',
      cfl: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 4v7a3.5 3.5 0 0 0 7 0V4"/><path d="M6.5 4h4m3 0h4M11 20h2"/></svg>',
      smart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="16.5" r="1.3"/><path d="M8.7 13.3a5 5 0 0 1 6.6 0M6.3 10.7a8.5 8.5 0 0 1 11.4 0"/></svg>',
      dim: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.5"/><path d="M12 3.5v2M12 18.5v2M3.5 12h2M18.5 12h2M6 6l1.4 1.4M16.6 16.6 18 18M6 18l1.4-1.4M16.6 7.4 18 6"/></svg>',
      ballast: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="7" width="16" height="10" rx="1.6"/><path d="M8 7V5m8 2V5M8 19v-2m8 2v-2"/></svg>',
      luminaire: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v2.5M6.5 13a5.5 5.5 0 0 1 11 0Z"/><path d="M5.5 13h13M10 17l-1 3.5m6-3.5 1 3.5"/></svg>',
      battery: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="15" height="8" rx="1.5"/><path d="M21 11v2M7 12h4"/></svg>',
      tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h7l9 9-7 7-9-9V4Z"/><circle cx="8.5" cy="8.5" r="1.4"/></svg>',
      book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15.5H6.5A2.5 2.5 0 0 0 4 21V5.5Z"/><path d="M4 18.5A2.5 2.5 0 0 1 6.5 16H20"/></svg>',
      plug: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3v5m6-5v5M7 8h10v3a5 5 0 0 1-5 5 5 5 0 0 1-5-5V8Z"/><path d="M12 16v5"/></svg>'
    };
    function iconFor(name) {
      var n = (name || '').toLowerCase();
      if (/marke|hersteller/.test(n)) { return I.tag; }
      if (/ratgeber|wissen|hilfe|service/.test(n)) { return I.book; }
      if (/batterie|knopfzelle|mignon|micro|block|baby|mono|akku|zelle/.test(n)) { return I.battery; }
      if (/röhre|roehre|leuchtstoff/.test(n)) { return I.tube; }
      if (/reflektor|strahler|spot/.test(n)) { return I.spot; }
      if (/stiftsockel/.test(n)) { return I.pin; }
      if (/kompakt|energiespar/.test(n)) { return I.cfl; }
      if (/smart/.test(n)) { return I.smart; }
      if (/dimmbar|dimmer/.test(n)) { return I.dim; }
      if (/vorschaltger|trafo|treiber|betriebsger/.test(n)) { return I.ballast; }
      if (/zubehör|zubehoer|stecksystem|wago|wallbox|installation|kabel|steuerung/.test(n)) { return I.plug; }
      if (/leuchte|panel|downlight|flutlicht|leiste|lichtband/.test(n)) { return I.luminaire; }
      return I.bulb;
    }

    // Spalten-Icon: optional je Gruppe im Panel-JSON ("gi"). Ohne gi bleibt die
    // Namensheuristik. Grund: iconFor(panelname + gruppenname) trifft im Ratgeber-Panel
    // immer zuerst /ratgeber|wissen/ — alle Spalten bekaemen dasselbe Buch-Icon.
    function groupIcon(key, g) {
      return (g.gi && I[g.gi]) ? I[g.gi] : iconFor(key + ' ' + g.n);
    }

    var MENU = parseJSON('[data-lmm-menu]') || {};
    var MFR = parseJSON('[data-lmm-mfr]') || {};
    // DRAFT-TEST: Bild-/Produktvisuals je Panel (nur Menues mit Eintrag; sonst unveraendert).
    var VIS = parseJSON('[data-lmm-visuals]') || {};
    // DRAFT-TEST: Hover-/Focus-Previews je Menuelink (Collection-URL -> {img,title,text,alt}); nur LED-Lampen.
    var HVIS = parseJSON('[data-lmm-hover-visuals]') || {};
    // ---- Dynamische Counts (Single Source: data-lmm-counts, live aus Shopify). ----
    // Keine hart codierten Zahlen mehr; Count wird per URL->Handle aufgeloest und nur
    // gezeigt, wenn die Collection existiert und >0 Produkte hat (sonst ausgeblendet).
    var COUNTS = parseJSON('[data-lmm-counts]') || {};
    // ---- PDP-Standort (nur Produktseiten; sonst null). Siehe data-lmm-pdp-ctx oben. ----
    var PDPCTX = parseJSON('[data-lmm-pdp-ctx]') || null;
    // ---- Ratgeber-Link-Hygiene: nur published Ratgeber-Artikel-Links zeigen. ----
    // Handle steht in RGPUBSET => published => Link erlaubt; sonst blockiert (kein 404).
    // Betrifft NUR /blogs/ratgeber/<handle> (Artikel); Index /blogs/ratgeber + /pages bleiben.
    var RGPUB = parseJSON('[data-lmm-rg-pub]') || [];
    var RGPUBSET = {};
    // Handles normalisieren: Liquid liefert je nach Quelle "ratgeber/<handle>" oder "<handle>".
    (RGPUB || []).forEach(function (h) { RGPUBSET[String(h).split('/').pop()] = true; });
    function ratgeberBlocked(u) {
      var s = String(u || '');
      // Themenuebersichten sind Blog-TAG-Seiten, keine Artikel — nie ueber die Artikel-Liste pruefen
      // (die alte Regex hat "tagged" als Handle gelesen und alle Themenlinks verschluckt).
      if (s.indexOf('/blogs/ratgeber/tagged/') !== -1) { return false; }
      var m = /\/blogs\/ratgeber\/([a-z0-9-]+)/.exec(s);
      return m ? !Object.prototype.hasOwnProperty.call(RGPUBSET, m[1]) : false;
    }
    function handleOf(u) { var m = /\/collections\/([a-z0-9-]+)/.exec(u || ''); return m ? m[1] : ''; }
    function dynCount(u) {
      var h = handleOf(u);
      return (h && Object.prototype.hasOwnProperty.call(COUNTS, h)) ? COUNTS[h] : null;
    }

    // ---- Live-Collections: nur geprüfte, existierende Shopify-Handles. ----
    // Schlüssel = exakter Menü-Name -> { url }. Der Count kommt NICHT mehr von hier,
    // sondern dynamisch aus data-lmm-counts (url -> handle -> COUNTS). Kategorien OHNE
    // Eintrag bleiben sichtbar, aber NICHT klickbar (kein href => kein 404) und ohne Zahl.
    // Beim Anlegen weiterer Collections hier url + Handle in lmm_nav_handles ergänzen.
    var LIVE = {
      // --- Hersteller-Welle 1 (2026-07-01): 2 Hubs + 11 Marke×Kategorie. Keys = EXAKTE Menü-Label,
      // brandpräfixiert -> keine Kollision mit ptype-/Kategorie-Namen. count = echte Shopify-Collection-Zahl. ---
      'Osram': { url: '/collections/osram' },
      'Philips': { url: '/collections/philips' },
      'Osram Leuchtstoffröhren': { url: '/collections/osram-leuchtstoffroehren' },
      'Osram Kompaktleuchtstofflampen (Dulux)': { url: '/collections/osram-kompaktleuchtstofflampen' },
      'Osram Halogenlampen': { url: '/collections/osram-halogen' },
      'Osram LED-Röhren': { url: '/collections/osram-led-roehren' },
      'Osram E27 LED-Lampen': { url: '/collections/osram-e27-led' },
      'Osram E14 LED-Lampen': { url: '/collections/osram-e14-led' },
      'Osram GU10-Reflektoren': { url: '/collections/osram-reflektor-gu10' },
      'Osram GU5.3-Reflektoren (12 V)': { url: '/collections/osram-reflektor-gu53' },
      'Osram Stiftsockellampen': { url: '/collections/osram-stiftsockel' },
      'Philips Leuchtstoffröhren': { url: '/collections/philips-leuchtstoffroehren' },
      'Philips Kompaktleuchtstofflampen (PL)': { url: '/collections/philips-kompaktleuchtstofflampen' },
      // --- Landingpage-Welle 2 (2026-07-02): 10 weitere Marke×Kategorie-Seiten (gebaut + verifiziert).
      // gu10-led-dimmbar bewusst NICHT hier (markenübergreifende Facette, kein Hersteller-Menüpunkt). ---
      'Osram T8 Leuchtstoffröhren': { url: '/collections/osram-t8-leuchtstoffroehren' },
      'Osram T5 Leuchtstoffröhren': { url: '/collections/osram-t5-leuchtstoffroehren' },
      'Osram Haloline': { url: '/collections/osram-haloline' },
      'Osram Decostar': { url: '/collections/osram-decostar' },
      'Osram Vorschaltgeräte': { url: '/collections/osram-vorschaltgeraete' },
      'Osram T8 LED-Röhren 120 cm': { url: '/collections/osram-t8-led-roehren-120-cm' },
      'Osram T8 LED-Röhren 150 cm': { url: '/collections/osram-t8-led-roehren-150-cm' },
      'Philips T8 Leuchtstoffröhren (TL-D)': { url: '/collections/philips-t8-leuchtstoffroehren' },
      'Philips T5 Leuchtstoffröhren (TL5)': { url: '/collections/philips-t5-leuchtstoffroehren' },
      'Philips GU10-Reflektoren': { url: '/collections/philips-reflektor-gu10' },
      // --- Hersteller-Komplettierungswelle (2026-07-02): Ledvance/Sylvania-Hubs + 2 Sylvania-
      // + 5 Philips-Kategorien (gebaut + verifiziert). Radium bewusst NICHT (nur Bericht). ---
      'Ledvance': { url: '/collections/ledvance' },
      // --- Ledvance-Leuchten-Welle (2026-07-03): 6 suchdatenbasierte Leuchten-Kategorien
      // (Scope-Gate 2026-07-03, Vendor NUR standalone LEDVANCE — Lampen bleiben bei Osram). ---
      'Ledvance Feuchtraumleuchten': { url: '/collections/ledvance-feuchtraumleuchten' },
      'Ledvance Einbaustrahler & Downlights': { url: '/collections/ledvance-einbaustrahler' },
      'Ledvance Außenleuchten (Endura)': { url: '/collections/ledvance-aussenleuchten' },
      'Ledvance LED-Fluter & Strahler': { url: '/collections/ledvance-fluter' },
      'Ledvance Unterbauleuchten': { url: '/collections/ledvance-unterbauleuchten' },
      'Ledvance LED-Panels': { url: '/collections/ledvance-led-panel' },
      'Sylvania': { url: '/collections/sylvania' },
      'Sylvania Leuchtstoffröhren': { url: '/collections/sylvania-leuchtstoffroehren' },
      'Sylvania Kompaktleuchtstofflampen (Lynx)': { url: '/collections/sylvania-kompaktleuchtstofflampen' },
      'Philips LED-Röhren': { url: '/collections/philips-led-roehren' },
      'Philips E27 LED-Lampen': { url: '/collections/philips-e27-led' },
      'Philips E14 LED-Lampen': { url: '/collections/philips-e14-led' },
      'Philips Vorschaltgeräte': { url: '/collections/philips-vorschaltgeraete' },
      'Philips GU5.3-Reflektoren (12 V)': { url: '/collections/philips-reflektor-gu53' }
    };
    function liveOf(name) {
      return Object.prototype.hasOwnProperty.call(LIVE, name) ? LIVE[name] : null;
    }
    function liveCount(name, cls) {
      var lv = liveOf(name);
      var dc = lv ? dynCount(lv.url) : null;
      return (dc != null) ? '<span class="' + (cls || 'lmmh-mc') + '">' + num(dc) + '</span>' : '';
    }
    // String-Menüeintrag: existierende Collection -> <a href> (+ Count via opts.count);
    // sonst nicht klickbarer <a class="lmmh-soon"> ohne href (kein 404) und ohne Count.
    function entry(name, inner, opts) {
      opts = opts || {};
      var lv = liveOf(name);
      var body = inner + (opts.count ? liveCount(name, opts.countCls) : '');
      var cls = opts.cls || '';
      if (lv && lv.url) { return '<a' + (cls ? ' class="' + cls + '"' : '') + ' href="' + lv.url + '">' + body + '</a>'; }
      return '<a class="' + ('lmmh-soon' + (cls ? ' ' + cls : '')) + '" aria-disabled="true">' + body + '</a>';
    }

    /* ---------- Mega-Panels (Header v1: kuratierte MENU-Daten) ----------
       Rendert die fokussierten Bereichs-Panels UND das „Alle Kategorien"-Gesamt-Mega
       (6 Spalten + Fußzeile „Weitere Sortimente") aus dem MENU-JSON. Nur geprüfte
       Ziele — Items ohne URL werden ÜBERSPRUNGEN (Deferred erscheint nicht im Header,
       nur in der Doku: header-link-map.csv). Kuratierte Reihenfolge = Array-Reihenfolge. */
    function itemLink(it, cls) {
      if (!it || !it.u) { return ''; }
      if (ratgeberBlocked(it.u)) { return ''; }
      var dc = dynCount(it.u);
      var cnt = (dc != null) ? '<span class="lmmh-mc">' + num(dc) + '</span>' : '';
      return '<a' + (cls ? ' class="' + cls + '"' : '') + ' href="' + esc(it.u) + '"><span>' + softHyph(esc(it.n)) + '</span>' + cnt + '</a>';
    }
    /* Desktop-Mega: Watt-Orientierung der klassischen T5-/T8-Roehrenlaengen (2026-08-09).
       Bewusst KEIN pauschales Rendern von it.s — dasselbe Feld tragen auch die LED-Roehren
       (Ersatz-Hinweise) und die Ratgeber-Themenlinks (Themenuebersicht). Deshalb Whitelist auf
       die exakten Collection-Handles der beiden Laengen-Gruppen; die beiden Hubs
       (t8-/t5-leuchtstoffroehren) stehen bewusst NICHT darin. Klassische Roehren bleiben eine
       reine Orientierung und nie eine Ersatz-, Laengen- oder Kompatibilitaetsregel.
       Der mobile Drawer rendert it.s unveraendert ueber seinen eigenen Wrapper — der
       Renderpfad hier ist desktop-only. */
    var MEGA_NOTE_HANDLES = {
      't8-roehren-600mm': 1, 't8-roehren-900mm': 1, 't8-roehren-1200mm': 1,
      't8-roehren-1500mm': 1, 't8-roehren-sonderlaengen': 1,
      't5-roehren-549mm': 1, 't5-roehren-849mm': 1, 't5-roehren-1149mm': 1,
      't5-roehren-1449mm': 1, 't5-kurzroehren': 1
    };
    function megaItem(it) {
      var html = itemLink(it);
      if (html && it && it.s && MEGA_NOTE_HANDLES[handleOf(it.u)]) {
        html = html.replace('</span>', '<small class="lmmh-mnote">' + esc(it.s) + '</small></span>');
      }
      return html;
    }
    /* Lazy-Build 2026-07-26: Der Panel-Aufbau lief bisher bei JEDEM Seitenaufruf sofort und
       erzeugte ~2.280 DOM-Knoten, obwohl die Panels bis zur ersten Nutzeraktion display:none
       sind. Der Rumpf ist unveraendert — nur in eine Funktion gekapselt, die ensureMegaPanelsBuilt()
       beim ersten Nutzerkontakt genau einmal aufruft. */
    function buildMegaPanels() {
    root.querySelectorAll('.lmmh-nav__item--mega[data-menu-panel]').forEach(function (item) {
      var key = item.getAttribute('data-menu-panel');
      var host = item.querySelector('[data-mega-host]');
      if (!host) { return; }

      /* --- Gesamt-Mega „Alle Kategorien": 6 Spalten + Fußzeile (K1-Entscheid) --- */
      if (key === '_allcats') {
        var ac = MENU.allcats || {};
        var html = '<div class="lmmh-allcats__cols">';
        (ac.cols || []).forEach(function (col) {
          html += '<div class="lmmh-grp lmmh-allcats__col">';
          var head = '<span class="lmmh-grp__label"><span class="lmmh-gico" aria-hidden="true">' + iconFor(col.n) + '</span><span class="lmmh-grp__text">' + softHyph(esc(col.n)) + '</span></span>';
          if (col.u) {
            html += '<h3 class="lmmh-grp__head"><a class="lmmh-grp__headlink" href="' + esc(col.u) + '">' + head + '</a></h3>';
          } else {
            html += '<h3 class="lmmh-grp__head">' + head + '</h3>';
          }
          html += '<ul>';
          (col.items || []).forEach(function (it) { if (it.u && !ratgeberBlocked(it.u)) { html += '<li>' + itemLink(it) + '</li>'; } });
          if (col.all && col.all.u) { html += '<li>' + itemLink(col.all, 'lmmh-allcats__all') + '</li>'; }
          html += '</ul></div>';
        });
        html += '</div>';
        // DRAFT-TEST (Welle 3B): kompakter Bild-Streifen der 4 Produktbereiche. Reused, bereits
        // visuell geprüfte VIS-Bilder; Marken/Ratgeber bewusst OHNE Bild. Nur „Alle Kategorien"
        // (Panel ist ohnehin desktop-only). Bei fehlendem VIS-Eintrag wird die Karte übersprungen.
        (function allcatsVisualStrip() {
          var keys = ['LED-Lampen', 'LED-Röhren', 'Leuchtmittel', 'Leuchten', 'Zubehör'];
          var cards = '';
          keys.forEach(function (sk) {
            var v = VIS[sk];
            if (!v || !(v.tiles || []).length) { return; }
            var t = v.tiles[0];
            var url = (v.cta && v.cta.u) ? v.cta.u : (t.u || '');
            if (!url || !t.img) { return; }
            var dc = dynCount(url);
            var cnt = (dc != null) ? '<span class="lmmh-acv__count">' + num(dc) + ' Artikel</span>' : '';
            cards += '<a class="lmmh-acv__card" href="' + esc(url) + '"><img src="' + esc(t.img) + '" alt="" width="46" height="46" loading="lazy" decoding="async"><span class="lmmh-acv__t">' + esc(sk) + '</span>' + cnt + '</a>';
          });
          if (cards) { html += '<div class="lmmh-allcats__visstrip" aria-label="Bereiche im Bild"><span class="lmmh-acv__lbl">Bereiche im Bild</span>' + cards + '</div>'; }
        })();
        var more = ac.more || {};
        if ((more.items || []).length) {
          html += '<div class="lmmh-allcats__more"><span class="lmmh-allcats__more-lbl">' + esc(more.label || 'Weitere Sortimente') + ':</span>';
          more.items.forEach(function (it) { if (it.u) { html += itemLink(it, 'lmmh-allcats__more-link'); } });
          html += '</div>';
        }
        host.innerHTML = html;
        return;
      }

      /* --- Fokussierte Bereichs-Panels --- */
      var panel = (MENU.panels || {})[key];
      if (!panel) { return; }
      var phtml = '';
      (panel.groups || []).forEach(function (g) {
        var items = (g.items || []).filter(function (it) { return it.u && !ratgeberBlocked(it.u); });
        if (!items.length) { return; }
        phtml += '<div class="lmmh-grp">';
        phtml += '<h3 class="lmmh-grp__head"><span class="lmmh-grp__label"><span class="lmmh-gico" aria-hidden="true">' + groupIcon(key, g) + '</span><span class="lmmh-grp__text">' + softHyph(esc(g.n)) + '</span></span></h3>';
        phtml += '<ul>';
        items.forEach(function (it) { phtml += '<li>' + megaItem(it) + '</li>'; });
        phtml += '</ul></div>';
      });
      // DRAFT-TEST: rechter Bild-Visual-Bereich, nur wenn fuer dieses Panel eine Visual-Map
      // existiert. Sonst wie bisher (nur Textspalten). Bilder = eigene Produktmedien, lazy.
      var vis = VIS[key];
      if (vis && (vis.tiles || []).length) {
        var vhtml = '<aside class="lmmh-mega__visual" aria-label="Bildvorschau ' + esc(key) + '"><p class="lmmh-mv__head">' + esc(vis.head || '') + '</p><div class="lmmh-mv__grid">';
        (vis.tiles || []).forEach(function (t) {
          if (!t.img || !t.u) { return; }
          vhtml += '<a class="lmmh-mv__tile" href="' + esc(t.u) + '"><img src="' + esc(t.img) + '" alt="' + esc(t.alt || '') + '" width="200" height="200" loading="lazy" decoding="async"><span>' + esc(t.label || '') + '</span></a>';
        });
        vhtml += '</div>';
        if (vis.cta && vis.cta.u) { vhtml += '<a class="lmmh-mv__cta" href="' + esc(vis.cta.u) + '">' + esc(vis.cta.n) + ' &rsaquo;</a>'; }
        vhtml += '</aside>';
        host.innerHTML = '<div class="lmmh-mega__cols">' + phtml + '</div>' + vhtml;
        host.classList.add('lmmh-mega__inner--visual');
        // DRAFT-TEST Hover-/Focus-Preview: nur wenn dieses Panel Links mit Eintrag in HVIS hat
        // (aktuell nur LED-Lampen). Default (4 Kacheln) bleibt; Hover/Fokus eines passenden Links
        // blendet rechts eine groessere Produktvorschau als Overlay ein (kein Reflow), mouseleave/
        // blur -> zurueck zum Default. A11y: mouseover UND focus; Links bleiben normale Links.
        (function attachHoverPreview() {
          if (!Object.keys(HVIS).length) { return; }
          var aside = host.querySelector('.lmmh-mega__visual');
          var cols = host.querySelector('.lmmh-mega__cols');
          if (!aside || !cols) { return; }
          function pathOf(u) { try { return new URL(u, location.origin).pathname; } catch (e) { var m = /(\/collections\/[a-z0-9-]+)/.exec(u || ''); return m ? m[1] : ''; } }
          var hasHover = false;
          cols.querySelectorAll('a[href]').forEach(function (a) { if (HVIS[pathOf(a.getAttribute('href'))]) { hasHover = true; } });
          if (!hasHover) { return; }
          aside.classList.add('lmmh-mega__visual--hoverable');
          var pv = document.createElement('div');
          pv.className = 'lmmh-mv__preview';
          pv.setAttribute('aria-hidden', 'true');
          pv.innerHTML = '<img alt="" width="150" height="130" decoding="async"><p class="lmmh-mv__pv-title"></p><p class="lmmh-mv__pv-count"></p><p class="lmmh-mv__pv-text"></p><a class="lmmh-mv__pv-cta" tabindex="-1" aria-hidden="true"></a>';
          aside.appendChild(pv);
          var pImg = pv.querySelector('img'), pT = pv.querySelector('.lmmh-mv__pv-title'), pN = pv.querySelector('.lmmh-mv__pv-count'), pX = pv.querySelector('.lmmh-mv__pv-text'), pC = pv.querySelector('.lmmh-mv__pv-cta');
          function show(href) {
            var k = pathOf(href), d = HVIS[k];
            if (!d) { hide(); return; }
            if (pImg.getAttribute('src') !== d.img) { pImg.src = d.img; }
            pImg.alt = d.alt || '';
            pT.textContent = d.title || '';
            var dc = dynCount(k);
            if (dc != null) { pN.textContent = num(dc) + ' Artikel'; pN.style.display = ''; } else { pN.textContent = ''; pN.style.display = 'none'; }
            pX.textContent = d.text || '';
            pC.textContent = 'Zur Kategorie ' + String.fromCharCode(0x203A);
            pC.setAttribute('href', k);
            pv.classList.add('is-visible');
          }
          function hide() { pv.classList.remove('is-visible'); }
          cols.addEventListener('mouseover', function (e) { var a = e.target.closest('a[href]'); if (a && cols.contains(a)) { show(a.getAttribute('href')); } });
          cols.addEventListener('mouseleave', hide);
          cols.addEventListener('focusin', function (e) { var a = e.target.closest('a[href]'); if (a) { show(a.getAttribute('href')); } });
          cols.addEventListener('focusout', function (e) { if (!cols.contains(e.relatedTarget)) { hide(); } });
        })();
      } else {
        host.innerHTML = phtml;
      }
      // Teaser unten: Ratgeber-Hinweis (nicht im Ratgeber-Panel selbst) + „Alle … ansehen ›".
      var teaser = document.createElement('div');
      teaser.className = 'lmmh-teaser';
      var allLink = (panel.all && panel.all.u) ? '<a href="' + esc(panel.all.u) + '">' + esc(panel.all.n) + ' &rsaquo;</a>' : '';
      var tl = '<div class="lmmh-teaser__links">';
      if (key !== 'Ratgeber & Wissen') {
        tl += '<span class="lmmh-teaser__lbl">Ratgeber</span><a href="/blogs/ratgeber">Kaufberatung &amp; Lichtfarbe erklärt</a>';
      } else if (panel.more && (panel.more.items || []).length) {
        // Ratgeber-Panel: die restlichen Themenuebersichten kompakt in der Fusszeile — alle 13
        // Themen bleiben erreichbar, ohne eine Spalte zu ueberladen.
        tl += '<span class="lmmh-teaser__lbl">' + esc(panel.more.label || 'Weitere Themen') + '</span>';
        panel.more.items.forEach(function (it) {
          if (it.u && !ratgeberBlocked(it.u)) { tl += '<a href="' + esc(it.u) + '">' + esc(it.n) + '</a>'; }
        });
      }
      tl += allLink + '</div>';
      teaser.innerHTML = tl;
      host.parentNode.appendChild(teaser);
    });
    }

    /* ---------- Hersteller-Flyout (Welle 1: dynamisch, 2 Bereiche) ----------
       Links = Markenliste (Osram/Philips als Hub-Link + Count, reservierte Marken als
       „folgt" ohne href), rechts = Kategorien-Panel der AKTIVEN Marke. Mouseover/Fokus
       auf eine Marke wechselt das Panel; Default = erste Marke (Osram). Skaliert für
       Ledvance/Sylvania/Radium: nur data-lmm-mfr + LIVE-Map ergänzen. Nur gebaute, in
       LIVE hinterlegte Handles sind klickbar (sonst lmmh-soon, kein 404).
       Lazy-Build 2026-07-26: war eine IIFE, ist jetzt eine benannte Funktion — Rumpf unveraendert,
       Aufruf uebernimmt ensureManufacturerFlyoutBuilt(). */
    function manufacturerFlyout() {
      var data = (MFR && MFR.manufacturers) || [];
      var soon = (MFR && MFR._soon) || [];
      var list = root.querySelector('[data-mfr-list]');
      var panel = root.querySelector('[data-mfr-panel]');
      var panelHead = root.querySelector('[data-mfr-panel-head]');
      var headTop = root.querySelector('[data-mfr-list-head]');
      if (!list || !panel || !data.length) { return; }

      // Markenliste: gebaute Hubs (Link + echter Count) + reservierte Marken (nicht klickbar).
      if (headTop) { headTop.innerHTML = '<span class="lmmh-gico" aria-hidden="true">' + I.tag + '</span>Top-Hersteller'; }
      var topHtml = '';
      data.forEach(function (m, i) {
        topHtml += '<li data-mfr-brand="' + i + '">' + entry(m.n, '<span>' + esc(m.n) + '</span>', { count: true }) + '</li>';
      });
      soon.forEach(function (name) {
        topHtml += '<li><a class="lmmh-soon" aria-disabled="true"><span>' + esc(name) + '</span>'
          + '<span class="lmmh-mfr-flag">folgt</span></a></li>';
      });
      list.innerHTML = topHtml;

      // Panel = Kategorien der aktiven Marke; aktive Marke in der Liste hervorheben.
      function showBrand(i) {
        var m = data[i];
        if (!m) { return; }
        list.querySelectorAll('[data-mfr-brand]').forEach(function (li) {
          li.classList.toggle('is-active', li.getAttribute('data-mfr-brand') === String(i));
        });
        if (panelHead) { panelHead.textContent = m.n; }
        var html = '';
        (m.c || []).forEach(function (c) {
          html += '<li>' + entry(c.n, '<span>' + esc(c.n) + '</span>', { count: true }) + '</li>';
        });
        panel.innerHTML = html || '<li class="lmmh-mfr-empty">Kategorien folgen.</li>';
      }

      list.querySelectorAll('[data-mfr-brand]').forEach(function (li) {
        var idx = parseInt(li.getAttribute('data-mfr-brand'), 10);
        li.addEventListener('mouseenter', function () { showBrand(idx); });
        li.addEventListener('focusin', function () { showBrand(idx); });
        // Tastatur: Pfeil-rechts springt von der Marke in ihr Kategorien-Panel.
        li.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') {
            var first = panel.querySelector('a[href]');
            if (first) { e.preventDefault(); first.focus(); }
          }
        });
      });
      showBrand(0);
    }

    /* ---------- Lazy-Build-Einstiege, getrennt je Oberflaeche (2026-07-26) ----------
       Die drei Oberflaechen (Desktop-Panels, Hersteller-Flyout, Mobile-Drawer) haben je einen
       eigenen idempotenten Einstieg mit eigenem Flag und werden GETRENNT gebaut — jeweils erst
       beim ersten echten Kontakt mit GENAU DIESER Oberflaeche. Vorher baute ein gemeinsamer
       Einstieg alle drei auf einmal; mobil kostete das den Drawer-Aufbau plus zwei
       Desktop-Komponenten, die dort gar nicht sichtbar werden.
       Kein DOMContentLoaded, kein load, kein Timer, kein requestIdleCallback, kein
       zusaetzlicher Netzwerkrequest — die Daten liegen bereits inline im Dokument.
       Jedes Flag wird VOR seinem Bauschritt gesetzt: ein Fokuswechsel waehrend des Aufbaus
       darf nicht rekursiv erneut bauen. */
    var lmmPanelsBuilt = false;
    function ensureMegaPanelsBuilt() {
      if (lmmPanelsBuilt) { return; }
      lmmPanelsBuilt = true;
      buildMegaPanels();
      root.dataset.lmmPanelsBuilt = '1';
    }
    var lmmMfrBuilt = false;
    function ensureManufacturerFlyoutBuilt() {
      if (lmmMfrBuilt) { return; }
      lmmMfrBuilt = true;
      manufacturerFlyout();
      root.dataset.lmmMfrBuilt = '1';
    }

    /* ---------- Panel-Trigger: Chevron/Top-Link toggelt Panel; Esc schließt ----------
       Verlinkte Top-Punkte (.lmmh-nav__item--linked) haben einen echten Text-Link + separaten
       Chevron-Button; dort ist der Button der Trigger, der Link navigiert normal. Reine
       Flyout-Punkte (role="button"-Link) togglen weiterhin über den Link selbst. */
    root.querySelectorAll('.lmmh-nav__item--mega').forEach(function (li) {
      var caretBtn = li.querySelector(':scope > .lmmh-nav__caret-btn');
      var link = li.querySelector(':scope > .lmmh-nav__link');
      var trigger = caretBtn || link;
      if (!trigger) { return; }
      /* Split-Lazy-Build 2026-07-26: Der Marken-Punkt (data-mfr-item) baut ausschliesslich das
         Hersteller-Flyout, jeder andere Mega-Punkt ausschliesslich die Desktop-Panels. Beide
         Mengen sind disjunkt: buildMegaPanels() iteriert nur [data-menu-panel], und der
         Marken-Punkt traegt dieses Attribut nicht. Der Mobile-Drawer wird hier NIE gebaut. */
      var ensureBuilt = li.hasAttribute('data-mfr-item')
        ? ensureManufacturerFlyoutBuilt : ensureMegaPanelsBuilt;
      function openPanel() {
        ensureBuilt();
        li.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
        var first = li.querySelector('.lmmh-mega a[href], .lmmh-mega button');
        if (first) { first.focus(); }
      }
      function closePanel() { li.removeAttribute('data-open'); trigger.setAttribute('aria-expanded', 'false'); }
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault(); openPanel();
        } else if (e.key === 'Escape') { closePanel(); trigger.focus(); }
      });
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (li.getAttribute('data-open') === 'true') { closePanel(); } else { openPanel(); }
      });
      // Verlinkter Top-Punkt: Esc auf dem Text-Link schließt das Panel (Link navigiert sonst normal).
      if (caretBtn && link) {
        link.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanel(); } });
      }
      /* Lazy-Build 2026-07-26: CSS oeffnet das Panel per :hover und :focus-within. Beide
         Wege muessen den Aufbau ANSTOSSEN, bevor der Browser das Panel malt — die Handler
         laufen synchron im selben Task, also ist das Panel beim ersten Paint gefuellt.
         pointerenter deckt zusaetzlich Stift-/Touch-Pointer ab. */
      li.addEventListener('pointerenter', ensureBuilt);
      li.addEventListener('focusin', ensureBuilt);
      li.addEventListener('mouseenter', function () { ensureBuilt(); trigger.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function () { closePanel(); });
    });

    /* ---------- Mobiles Burger-Drawer ---------- */
    (function drawer() {
      var burger = root.querySelector('[data-lmm-burger]');
      var dr = root.querySelector('[data-lmm-drawer]');
      var nav = root.querySelector('[data-drawer-nav]');
      if (!burger || !dr || !nav) { return; }

      // Drawer-Inhalt (Header v1) aus dem kuratierten MENU-JSON:
      // Ebene 1 = die 6 Bereiche (statt „Alle Kategorien" — die Ebene 1 IST die Übersicht),
      // Ebene 2 = Gruppen als Unter-Accordions, Ebene 3 = Links. Nur geprüfte Ziele
      // (Items ohne URL erscheinen mobil GAR NICHT — keine toten Zeilen).
      /* Lazy-Build 2026-07-26: Rumpf unveraendert, nur gekapselt. Der Drawer ist bis zum
         Oeffnen `hidden`; sein Inhalt (~850 Knoten) wurde bisher trotzdem bei jedem
         Seitenaufruf gebaut. open() ruft ensureDrawerNavBuilt() vor dem Sichtbarmachen. */
      function buildDrawerNav() {
      var NAV_ORDER = ['LED-Lampen', 'LED-Röhren', 'Leuchtmittel', 'Leuchten', 'Elektroinstallation', 'Zubehör'];
      var dhtml = '';
      function dsum(label, icon) {
        return '<summary><span class="lmmh-gico" aria-hidden="true">' + icon + '</span><span class="lmmh-dsl">' + label + '</span></summary>';
      }
      /* Drawer-only: optionale Subline it.s (z. B. „typischer Ersatz für 18 W" bei den
         Röhren-Längen) unter dem Linknamen — das Desktop-Mega ignoriert das Feld. */
      function drawerItem(it) {
        var html = itemLink(it);
        if (html && it && it.s) {
          html = html.replace('</span>', ' <small class="lmmh-dnote">' + esc(it.s) + '</small></span>');
        }
        return html;
      }
      NAV_ORDER.forEach(function (key) {
        var panel = (MENU.panels || {})[key];
        if (!panel) { return; }
        dhtml += '<li><details>' + dsum(esc(key), iconFor(key)) + '<div class="lmmh-drawer__sub">';
        if (panel.all && panel.all.u) { dhtml += itemLink(panel.all); }
        (panel.groups || []).forEach(function (g) {
          var items = (g.items || []).filter(function (it) { return it.u && !ratgeberBlocked(it.u); });
          if (!items.length) { return; }
          dhtml += '<details><summary>' + esc(g.n) + '</summary><div class="lmmh-drawer__sub">';
          items.forEach(function (it) { dhtml += drawerItem(it); });
          dhtml += '</div></details>';
        });
        dhtml += '</div></details></li>';
      });
      // Marken: je Marke ein eigenes Accordion (bestehendes Muster, Label „Marken").
      var mfr = (MFR && MFR.manufacturers) || [];
      if (mfr.length) {
        dhtml += '<li><details>' + dsum('Marken', I.tag) + '<div class="lmmh-drawer__sub">';
        mfr.forEach(function (m) {
          dhtml += '<details><summary>' + esc(m.n) + '</summary><div class="lmmh-drawer__sub">';
          dhtml += entry(m.n, '<span>Alle ' + esc(m.n) + ' anzeigen</span>', { count: true });
          (m.c || []).forEach(function (c) {
            dhtml += entry(c.n, '<span>' + esc(c.n) + '</span>', { count: true });
          });
          dhtml += '</div></details>';
        });
        dhtml += '</div></details></li>';
      }
      // Ratgeber & Wissen: gruppiert wie die Sortiments-Panels (2026-07-26). Vorher eine flache
      // Liste aller Gruppen — mit den redaktionellen Zielen wird das mobil unuebersichtlich,
      // deshalb je Spalte ein eigenes Accordion + Uebersichtslink oben + „Weitere Themen".
      var rg = (MENU.panels || {})['Ratgeber & Wissen'];
      if (rg) {
        dhtml += '<li><details>' + dsum('Ratgeber &amp; Wissen', I.book) + '<div class="lmmh-drawer__sub">';
        if (rg.all && rg.all.u) { dhtml += itemLink(rg.all); }
        (rg.groups || []).forEach(function (g) {
          var items = (g.items || []).filter(function (it) { return it.u && !ratgeberBlocked(it.u); });
          if (!items.length) { return; }
          dhtml += '<details><summary>' + esc(g.n) + '</summary><div class="lmmh-drawer__sub">';
          items.forEach(function (it) { dhtml += drawerItem(it); });
          dhtml += '</div></details>';
        });
        var rgMore = (rg.more && (rg.more.items || []).length) ? rg.more : null;
        if (rgMore) {
          dhtml += '<details><summary>' + esc(rgMore.label || 'Weitere Themen') + '</summary><div class="lmmh-drawer__sub">';
          rgMore.items.forEach(function (it) { if (it.u && !ratgeberBlocked(it.u)) { dhtml += drawerItem(it); } });
          dhtml += '</div></details>';
        }
        dhtml += '</div></details></li>';
      }
      // „Weitere Sortimente" (K1-Fußzeile) auch mobil erreichbar.
      var moreM = (MENU.allcats || {}).more || {};
      if ((moreM.items || []).length) {
        dhtml += '<li><details>' + dsum(esc(moreM.label || 'Weitere Sortimente'), I.luminaire) + '<div class="lmmh-drawer__sub">';
        moreM.items.forEach(function (it) { if (it.u) { dhtml += itemLink(it); } });
        dhtml += '</div></details></li>';
      }
      nav.innerHTML = dhtml;
      }
      /* Split-Lazy-Build 2026-07-26: eigener idempotenter Einstieg nur fuer den Drawer.
         Der Burger baut damit weder Desktop-Panels noch Hersteller-Flyout — mobil werden
         beide nie sichtbar. Die Marken-Accordions im Drawer baut buildDrawerNav() selbst
         aus MFR; es besteht keine Abhaengigkeit zu manufacturerFlyout(). */
      var lmmDrawerBuilt = false;
      function ensureDrawerNavBuilt() {
        if (lmmDrawerBuilt) { return; }
        lmmDrawerBuilt = true;
        buildDrawerNav();
        root.dataset.lmmDrawerBuilt = '1';
      }

      /* Standort-Orientierung (Chris 26.07.2026): Beim Oeffnen des Drawers wird der
         Ast der AKTUELLEN Seite aufgeklappt + der Link markiert; fremde Aeste sind zu.
         location.pathname wird bei JEDEM open() frisch gelesen (PJAX-Filterwechsel). */
      /* Erweiterung 27.07.2026 — Produktseiten: Eine PDP ist selbst kein Menuepunkt, also
         traf `href === location.pathname` dort nie und der Drawer blieb komplett zugeklappt.
         Statt einer zweiten Navigationslogik bestimmen die folgenden Helfer nur das ZIEL;
         aufgeklappt wird danach mit exakt demselben Code wie auf Collection-Seiten. */

      // Deutsche Labels/Handles vergleichbar machen ("LED-Röhren" == "LED-Roehren").
      function normDe(s) {
        return String(s == null ? '' : s).toLowerCase()
          .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
          .replace(/[^a-z0-9]+/g, '');
      }
      // Label des Ebene-1-Bereichs, in dem ein Drawer-Link haengt (z. B. "LED-Röhren").
      // Die Links selbst haben kein eigenes <li>, closest('li') trifft daher Ebene 1.
      function areaLabelOf(a) {
        var li = a.closest('li');
        var det = li && li.firstElementChild;
        var sum = det && det.firstElementChild;
        var lbl = sum && sum.querySelector('.lmmh-dsl');
        return lbl ? lbl.textContent : '';
      }
      // Alle Collection-Links des Drawers als handle -> Link (erste Nennung = Menue-Reihenfolge).
      // Der Ebene-1-Ast „Marken" ist eine Hersteller-, keine Sortimentsebene und scheidet aus.
      function menuCollectionLinks() {
        var map = {};
        var links = nav.querySelectorAll('a[href^="/collections/"]');
        for (var i = 0; i < links.length; i++) {
          if (normDe(areaLabelOf(links[i])) === 'marken') { continue; }
          var h = handleOf(links[i].getAttribute('href'));
          if (h && !map[h]) { map[h] = links[i]; }
        }
        return map;
      }
      /* Sortimentskategorie der aktuellen PDP — deterministisch, in dieser Reihenfolge:
         1. Die Collection, ueber die der Nutzer das Produkt geoeffnet hat (Herkunfts-URL).
         2. Die fachlich spezifischste Produkt-Collection, die im Menue steht: die KLEINSTE
            gewinnt (Groesse aus COUNTS), Gleichstand alphabetisch nach Handle.
            Marken-Collections des eigenen Herstellers sind ausgeschlossen — sonst markiert
            eine Philips-Roehre „Philips" statt „T8 LED-Röhren (60 cm)".
         3. Produkttyp (= die Kategorie, die der PDP-Breadcrumb zeigt) als Rueckfall.
         Findet nichts ein Ziel, bleibt der Drawer wie bisher zugeklappt. */
      function pdpTarget(map) {
        if (!PDPCTX) { return null; }
        if (PDPCTX.cur && map[PDPCTX.cur]) { return map[PDPCTX.cur]; }
        var cols = (PDPCTX.cols || []).slice().sort();
        var vendor = normDe(PDPCTX.vendor);
        if (vendor.length < 3) { vendor = ''; }   // zu kurz -> keine sichere Marken-Erkennung
        var best = null, bestCount = 0;
        for (var i = 0; i < cols.length; i++) {
          var h = cols[i];
          if (!map[h]) { continue; }
          if (vendor && normDe(h).indexOf(vendor) === 0) { continue; }
          var c = Object.prototype.hasOwnProperty.call(COUNTS, h) ? COUNTS[h] : Infinity;
          if (best === null || c < bestCount) { best = map[h]; bestCount = c; }
        }
        if (best) { return best; }
        var t = normDe(PDPCTX.type);
        if (t) { for (var k in map) { if (normDe(k) === t) { return map[k]; } } }
        return null;
      }

      function revealCurrent() {
        var path = location.pathname;
        var links = nav.querySelectorAll('a[href]');
        var first = null;
        for (var i = 0; i < links.length; i++) {
          if (links[i].getAttribute('href') === path) {
            links[i].setAttribute('aria-current', 'page');
            if (!first) { first = links[i]; }
          } else {
            links[i].removeAttribute('aria-current');
          }
        }
        nav.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
        /* Produktseite: kein Selbst-Treffer -> Sortimentskategorie markieren. Bewusst
           "location" statt "page": die Kategorie IST nicht die aktuelle Seite. */
        if (!first) {
          var t = pdpTarget(menuCollectionLinks());
          if (t) { t.setAttribute('aria-current', 'location'); first = t; }
        }
        if (!first || path === '/') { return; }
        for (var d = first.closest('details'); d; d = d.parentElement && d.parentElement.closest('details')) {
          d.open = true;
        }
        if (first.scrollIntoView) { first.scrollIntoView({ block: 'center' }); }
      }

      var lastFocus = null;
      function open() {
        ensureDrawerNavBuilt();
        lastFocus = document.activeElement;
        dr.hidden = false;
        dr.setAttribute('data-open', 'true');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        revealCurrent();
        var c = dr.querySelector('.lmmh-drawer__close');
        if (c) { c.focus(); }
      }
      function close() {
        dr.removeAttribute('data-open');
        dr.hidden = true;
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
      }
      /* Lazy-Build 2026-07-26: pointerdown baut schon waehrend des Antippens (vor dem click),
         focusin deckt die reine Tastaturbedienung ab. open() sichert den Aufbau ohnehin ab. */
      burger.addEventListener('pointerdown', ensureDrawerNavBuilt);
      burger.addEventListener('focusin', ensureDrawerNavBuilt);
      /* Enter/Leertaste loesen am <button> ohnehin click aus; der explizite keydown-Hook
         baut den Drawer schon beim Tastendruck, analog zu pointerdown beim Tippen. */
      burger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { ensureDrawerNavBuilt(); }
      });
      burger.addEventListener('click', open);
      dr.querySelectorAll('[data-lmm-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dr.getAttribute('data-open') === 'true') { close(); } });
    })();
  })();
